import { Component, Input } from '@angular/core';
import { PopupFieldData } from 'src/app/features/designer-studio/edit-pdf-doc/models/doc.model';

@Component({
  selector: 'app-screen-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
  @Input() initOptions: PopupFieldData;
}
